<template>
  <div id="app">
    <div style="height:100%;overflow: auto;">
      <keep-alive :include="keepAliveRoutes">
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      keepAliveRoutes: []
    }
  },
  mounted() {
    this.keepAliveRoutes = this.$router.options.routes.filter(route => route.meta && route.meta.keepAlive || !route.meta).map(route => route.name);
  }
}
</script>

<style>
@import url(//at.alicdn.com/t/c/font_4772990_ojc2gtcwat.css);
@import url("@/assets/css/index.css");
@import url("@/assets/css/common.css");
@import url("@/assets/css/doc.css");
#app {
  font-family: PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

html {
  height: 100vh;
  margin: 0;
  background: rgb(255, 255, 255);
}

body {
  height: 100vh;
  margin: 0;
  background: rgb(255, 255, 255);
  /* overflow: hidden; */
}

p{ margin:0; padding:0; } 

table {
  text-align: center;
  border-spacing: 0;
  border-left: 1px solid #000;
  border-bottom: 1px solid #000;
}

table td, table th{
  border-top:1px solid #000;
  border-right: 1px solid #000;
  padding: 10px;
}
@media screen and (max-width:640px){
  #app {
    height: 100dvh;
  }
}

.count-node {
  position: absolute;
  display: none;
  height: 24px;
  padding: 0 8px;
  line-height: 22px;
  margin-left: 6px;
  background-color: #f4f4f5;
  border: 1px solid #e9e9eb;
  border-radius: 4px;
  color: #909399;
  font-size: 12px;
  box-sizing: border-box;
}
</style>
